import { queryOptions } from '@tanstack/react-query';

import { api, parseResponse } from '@/library/api/honoClient';

export const settingQueryKeys = {
  all: ['settings'] as const,
};

export const systemSettingQueryOptions = () =>
  queryOptions({
    queryKey: settingQueryKeys.all,
    queryFn: () => parseResponse(api.settings.get.$post()),
    staleTime: 60_000,
  });
